import React, { FC } from "react";
import classes from './Timer.module.css';
import useTimer from "./useTimer";

interface TimerProps {
  initialSeconds?: number;
}

const Timer: FC<TimerProps> = ({ initialSeconds = 60 }) => {
  const { remainingSeconds } = useTimer(initialSeconds);

  const percentage = (remainingSeconds / (initialSeconds || 1)) * 100;
  const isUrgent = remainingSeconds <= 5 && remainingSeconds > 0;
  const timeClass =
    percentage > 50
      ? classes.timeGreen
      : percentage > 20
        ? classes.timeOrange
        : classes.timeRed;

  return (
    <div className={classes.TimerWrapper}>
      <span className={classes.TimerTitle}>Time Left</span>
      <h3 className={`${classes.TimerSec} ${timeClass} ${isUrgent ? classes.blink : ''}`}>
        {remainingSeconds}s
      </h3>
    </div>
  );
};

export default Timer;
